require("!!D:\\lmx_repository\\logimax_wholesale\\khazanchi\\node_modules\\script-loader\\addScript.js")(require("!!D:\\lmx_repository\\logimax_wholesale\\khazanchi\\node_modules\\raw-loader\\index.js!D:\\lmx_repository\\logimax_wholesale\\khazanchi\\node_modules\\ng2-select2\\ng2-select2.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/ng2-select2/ng2-select2.js
// module id = 454
// module chunks = 19